import React, { FunctionComponent, useState } from 'react';
import AssetDetailsInformation from './AssetDetailsInformation';
import ImageCanvas from './ImageCanvas';
import { useNavigateWithinOrg } from '../utils/navigation';
import DeleteModal from './DeleteModal';
import { useProjectLibraryContext } from '../contexts/ProjectLibraryContext';
import LabelApprovalDetails from './LabelApprovalDetails';

const LabelDetails: FunctionComponent = () => {
    const [isDeleteModalVisible, setIsDeleteModalVisible] =
        useState<boolean>(false);

    const navigate = useNavigateWithinOrg();
    const { refresh } = useProjectLibraryContext();

    const handleDeleteConfirmation = () => {
        // if (reviewResult) {
        //     setIsDeleteModalVisible(false);
        //     setReviewResult(null);
        //     deleteAsset(reviewResult.id)
        //         .then(() => {
        //             refresh().then(() => {
        //                 navigate('/library');
        //             });
        //         })
        //         .catch((error) => {
        //             console.error('Error deleting asset:', error);
        //             alert('Error deleting asset');
        //         });
        // }
    };

    return (
        <>
            <DeleteModal
                isActive={isDeleteModalVisible}
                onClose={() => setIsDeleteModalVisible(false)}
                onDelete={() => handleDeleteConfirmation()}
            />
            <div className="label-details-container">
                <LabelApprovalDetails />
                <div className="lower-container">
                    <div className="left-container">
                        <ImageCanvas />
                    </div>
                    <div className="right-container">
                        {/* <AssetDetailsTitleBar
                            handleDelete={() => setIsDeleteModalVisible(true)}
                        /> */}
                        <AssetDetailsInformation />
                    </div>
                </div>
            </div>
        </>
    );
};

export default LabelDetails;
